// Generated from src/img/svg/warning.svg

export const Warning = (props) => {
  return (
    <svg viewBox="0 0 64 64" {...props}>
      <g className="warning_svg__icon-poster" fill="none" fillRule="evenodd">
        <g className="warning_svg__icon-style">
          <path
            d="m32 14 17 31H15l17-32z"
            fill="#fff"
            stroke="#fff"
            strokeWidth="2"
          />
          <path
            className="warning_svg__base"
            d="M32 11.984c-1.49 0-2.859.82-3.56 2.134L13.493 42.076a4.037 4.037 0 0 0 3.56 5.94h29.891a4.037 4.037 0 0 0 3.56-5.94L35.56 14.118A4.04 4.04 0 0 0 32 11.984m0 2c.751 0 1.442.414 1.796 1.077l14.946 27.958a2.037 2.037 0 0 1-1.797 2.997h-29.89a2.037 2.037 0 0 1-1.797-2.997l14.945-27.958A2.04 2.04 0 0 1 32 13.984"
            fill="#282D37"
            fillRule="nonzero"
          />
          <path
            className="warning_svg__pulse"
            d="M32 39.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M32 22a1 1 0 0 1 .993.883L33 23v13a1 1 0 0 1-1.994.117L31 36V23a1 1 0 0 1 1-1"
            fill="#EC0016"
          />
        </g>
      </g>
    </svg>
  );
};
